import projetosRotas from './projetos/ProjetosRotas'
import pagamentosRotas from './pagamentos/PagamentosRotas'
import EtapasRotas from './etapas/EtapasRotas'

export default {
    path: 'uabs',
    name: 'Sgtec_Uabs',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [projetosRotas, pagamentosRotas, ...EtapasRotas]
}
